import styled from "styled-components";

export const EndAdornment = styled.button`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  transform-origin: center;
  padding: 0;
`;
